module.exports = __webpack_public_path__ + "static/img/4areaB_11.e24522c.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/4areaB_11.png
// module id = 1184
// module chunks = 1